import { Component, Input, Output, EventEmitter, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { UserService } from '../../../user/services/user.service';
import { Address, Dependent } from '../../../user/models/user-profile.model';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { LoaderService } from '../../../../shared/services/loader.service';
import { AsisstancesConfirmDialogComponent } from '../assistances-confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { VialAssistanceRequest } from '../models/vial-assistance-request.model';
import { VialAssistanceService } from '../services/vial-assistance.service';
import { VialAssistanceSubserviceRequest } from '../models/vial-assistance-subservice-request.model';


@Component({
  selector: 'app-vial-assistance',
  imports: [
    FormsModule,
    MatIconModule,
    MatRadioModule,
    MatProgressBarModule,
    MatFormFieldModule,
    MatSelectModule,
    MatButtonModule,
    CommonModule,
    MatSnackBarModule,
  ],
  templateUrl: './vial-assistance.component.html',
  styleUrl: './vial-assistance.component.scss',
})
export class VialAssistanceComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() currentMapLocation: any = null;
  @Input() isLoadingLocation: boolean = false;
  @Input() showMapSearchInput: boolean = false;
  @Input() serviceData: any = null;
  @Input() set mapMovedManually(moved: boolean) {
    if (moved) {
      this.selectedAddress = null;
    }
  }
  @Output() addressSelected = new EventEmitter<any>();
  @Output() enableMapSearch = new EventEmitter<void>();
  @Output() disableMapSearch = new EventEmitter<void>();
  @Output() searchAddress = new EventEmitter<string>();

  isEditingCurrentLocation: boolean = false;
  isSearching: boolean = false;

  @ViewChild('searchInput') searchInput: any;

  progressValue = 33; // Paso 1 de 3
  selectedVehicle = '';
  blindaje = false;
  nivelBlindaje: string | null = null;
  addresses: Address[] = [];
  selectedAddress: any = null;
  showAllAddresses = false;
  vehicles: any[] = [];
  showAllVehicles = false;
  nameService:string | null = null;
  vehicleSelected: any;
  dependent: Dependent[] = [];
  selectedPatient = 'titular';
  nameOwner: string = '';
  phoneOwner: string = '';
  keyOwner: string = '';
  showAllDependents = false;

  clServicio: number = 0;
  clSubservicio:number =0;
  dsSubServicio:string = "";
  email: string = '';

  constructor(private userService: UserService, private router:Router, private route:ActivatedRoute,
    private snackBar: MatSnackBar, private loader:LoaderService, private dialog: MatDialog,
    private apiService: VialAssistanceService
  ) {}

  goToStep(step: number) {
    // Aquí iría la lógica para avanzar al siguiente paso
    if(step == 2 ){
      console.log(' *********** ')
      console.log(this.currentMapLocation);
      console.log(this.selectedAddress);
      console.log(' *********** ')

      if(!this.vehicleSelected)
      {
        this.snackBar.open('Para continuar, seleccione un vehículo', 'Cerrar', {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'bottom'
        });
        return;
      }
      if(!this.selectedAddress && !this.currentMapLocation)
      {
        this.snackBar.open('Para continuar, seleccione una dirección', 'Cerrar', {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'bottom'
        });
        return;
      }

      // Obtener parámetros desde queryParams o desde el state si no están en queryParams
      this.route.queryParams.subscribe(params => {
        if(params && params['dsSubservicio']){
          this.dsSubServicio = params['dsSubservicio'];
          this.clServicio = params['clServicio'] || this.clServicio;
          this.clSubservicio = params['clSubservicio'] || this.clSubservicio;
        }
      })

      this.goToConfirm();
    }
  }

  selectedDate: Date | null = null;
  selectedTime: string = '';

  ngOnInit() {
    const userData = localStorage.getItem('user');
    if (userData) {
      const userObj = JSON.parse(userData);
      this.nameOwner = userObj.name || '';
      this.phoneOwner = userObj.phone || '';
      this.keyOwner = userObj.memberships || '';
      this.email = userObj.email || '';
    }

    // Obtener datos del servicio desde el Input serviceData
    if (this.serviceData) {
      this.dsSubServicio = this.serviceData.dsSubServicio || '';
      this.clServicio = this.serviceData.clServicio || 0;
      this.clSubservicio = this.serviceData.clSubServicio || 0;
    }

    // Fallback: obtener desde el state de navegación
    if (!this.dsSubServicio) {
      const state = history.state;
      if (state && state.dsSubServicio) {
        this.dsSubServicio = state.dsSubServicio;
        this.clServicio = state.clServicio || 0;
        this.clSubservicio = state.clSubServicio || 0;
      }
    }

    this.getDetailUser();
  }

  ngOnDestroy(): void {
    // Marcar que se necesita recargar la página al cerrar
    localStorage.setItem('needsPageReload', 'true');
  }

  getDetailUser() {
    const cognitoId = localStorage.getItem('cognito');
    if (cognitoId) {
      this.userService.getUserProfile(cognitoId).subscribe({
        next: (res) => {
          this.addresses = res.address;
          this.vehicles = res.vehicles || [];
          this.dependent = res.dependents || [];
        },
        error: (err) => console.error('Error al obtener perfil', err)
      });
    }
  }

  selectAddress(dir: any) {
    console.log('Dirección seleccionada en vial:', dir);
    this.selectedAddress = dir;

    // Si es ubicación actual, recargar ubicación real del usuario
    if (dir.isCurrentLocation) {
      this.getCurrentLocation();
      return;
    }

    // Para direcciones guardadas
    if (!dir.isCurrentLocation) {
      this.disableMapSearch.emit();
      this.isEditingCurrentLocation = false;
    }

    // Emitir la dirección seleccionada al componente padre
    if (dir.lat && dir.lng) {
      const addressData = {
        lat: parseFloat(dir.lat),
        lng: parseFloat(dir.lng),
        address: dir.isCurrentLocation ?
          dir.identifier :
          `${dir.streetNumber} Int ${dir.interiorDepartament || ''}, ${dir.colony || ''}, ${dir.cp || ''}, ${dir.municipality || ''}, ${dir.state || ''}`,
        timestamp: Date.now()
      };
      console.log('Emitiendo addressData desde vial:', addressData);
      this.addressSelected.emit(addressData);
    } else {
      console.log('No hay coordenadas en la dirección vial:', dir);
    }
  }

  ngAfterViewInit() {
    // Recargar vehículos si regresamos de agregar vehículo
    const vehicleAdded = sessionStorage.getItem('vehicleAdded');
    if (vehicleAdded === 'true') {
      sessionStorage.removeItem('vehicleAdded');
      this.getDetailUser();
    }

    // Recargar direcciones si regresamos de agregar dirección
    const addressAdded = sessionStorage.getItem('addressAdded');
    if (addressAdded === 'true') {
      sessionStorage.removeItem('addressAdded');
      this.getDetailUser();
    }

    // Recargar dependientes si regresamos de agregar dependiente
    const dependentAdded = sessionStorage.getItem('dependentAdded');
    if (dependentAdded === 'true') {
      sessionStorage.removeItem('dependentAdded');
      this.getDetailUser();
    }
  }

  onSearchInput(event: any) {
    const value = event.target.value;
    if (value && value.length > 2) {
      this.isSearching = true;
      this.searchAddress.emit(value);
    } else {
      this.isSearching = false;
    }
  }

  toggleEditCurrentLocation(event: Event) {
    event.stopPropagation();
    this.isEditingCurrentLocation = !this.isEditingCurrentLocation;

    if (this.isEditingCurrentLocation) {
      this.enableMapSearch.emit();
      // Inicializar autocompletado en el input integrado
      setTimeout(() => {
        this.initializeAutocomplete();
      }, 100);
    } else {
      this.disableMapSearch.emit();
      this.isSearching = false;
    }
  }

  initializeAutocomplete() {
    if (!this.searchInput || !this.searchInput.nativeElement) {
      return;
    }

    if (typeof google === 'undefined' || !google.maps || !google.maps.places) {
      return;
    }

    try {
      const autocomplete = new google.maps.places.Autocomplete(
        this.searchInput.nativeElement,
        {
          types: ['establishment', 'geocode'],
        }
      );

      google.maps.event.addListener(autocomplete, 'place_changed', () => {
        const place = autocomplete.getPlace();
        this.isSearching = false;

        if (place && place.geometry && place.geometry.location) {
          const addressData = {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
            address: place.formatted_address || place.name || 'Ubicación seleccionada'
          };
          this.addressSelected.emit(addressData);
        }
      });
    } catch (error) {
      console.error('Error inicializando autocompletado:', error);
    }
  }

  toggleAddresses() {
    this.showAllAddresses = !this.showAllAddresses;
  }

  toggleVehicles() {
    this.showAllVehicles = !this.showAllVehicles;
  }

  toggleDependents() {
    this.showAllDependents = !this.showAllDependents;
  }

  getSelectedVehicle() {
    this.vehicleSelected = this.vehicles.find(vehicle => vehicle.id === this.selectedVehicle);
    return this.vehicleSelected;
  }

  getSelectedVehicleShielding(): boolean {
    const vehicle = this.getSelectedVehicle();
    return vehicle ? vehicle.shielding : false;
  }

  getSelectedVehicleShieldingLevel(): string {
    const vehicle = this.getSelectedVehicle();
    return vehicle && vehicle.shieldingCatalog ? vehicle.shieldingCatalog.description : 'Sin Blindaje';
  }

  toggleShielding() {
    // En este caso, el blindaje es informativo basado en los datos del vehículo
    // No se puede cambiar desde la interfaz
    console.log('Blindaje del vehículo:', this.getSelectedVehicleShielding());
  }

  confirmSelection() {
    console.log('Fecha:', this.selectedDate);
    console.log('Hora:', this.selectedTime);
  }

  goToAddVehicles():void{
    this.router.navigate(['/add-vehiculo'], { queryParams: { returnUrl: this.router.url } });
  }

  goToAddAddress():void{
    this.router.navigate(['/add-direccion'], { queryParams: { returnUrl: this.router.url } });
  }

  addNewDependent() {
    sessionStorage.setItem('dependentAdded', 'true');
    this.router.navigate(['add-dependiente'], { queryParams: { returnUrl: this.router.url } });
  }

  isSelected(value: string): boolean {
    return this.selectedPatient === value;
  }

  private getCurrentLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.getAddressFromCoordinates(
            position.coords.latitude,
            position.coords.longitude
          );
        },
        (error) => {
          console.error('Error obteniendo ubicación:', error);
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0
        }
      );
    }
  }

  private getAddressFromCoordinates(lat: number, lng: number) {
    if (typeof google !== 'undefined' && google.maps) {
      const geocoder = new google.maps.Geocoder();
      const latlng = { lat, lng };

      geocoder.geocode({ location: latlng }, (results: any, status: any) => {
        if (status === 'OK' && results && results.length > 0) {
          let bestAddress = results[0].formatted_address;

          for (let result of results) {
            const address = result.formatted_address;
            if (!address.match(/^[A-Z0-9]{4}\+[A-Z0-9]{2}/)) {
              if (address.match(/\d+/)) {
                bestAddress = address;
                break;
              }
              if (!bestAddress.match(/^[A-Z0-9]{4}\+[A-Z0-9]{2}/)) {
                bestAddress = address;
              }
            }
          }

          const addressData = {
            lat,
            lng,
            address: bestAddress,
            timestamp: Date.now(),
            isCurrentLocation: true
          };
          this.addressSelected.emit(addressData);
        } else {
          const addressData = {
            lat,
            lng,
            address: 'Ubicación actual',
            timestamp: Date.now(),
            isCurrentLocation: true
          };
          this.addressSelected.emit(addressData);
        }
      });
    } else {
      const addressData = {
        lat,
        lng,
        address: 'Ubicación actual',
        timestamp: Date.now(),
        isCurrentLocation: true
      };
      this.addressSelected.emit(addressData);
    }
  }

  goToConfirm(): void {
      const dialogRef = this.dialog.open(AsisstancesConfirmDialogComponent);
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.loader.show();
          const userData = JSON.parse(localStorage.getItem('user') || '{}');
          const account = localStorage.getItem('account') ? parseInt(localStorage.getItem('account') || '1') : 1;
          const vehicle = this.vehicleSelected || {};

          // Obtener solicitudData del localStorage
          const solicitudData = JSON.parse(localStorage.getItem('solicitudData') || '{}');
          const serviceData = solicitudData.servicio || {};

          let latitude = '';
          let longitude = '';
          const currentCode = {
            cp: '', callenum: '', statecode: '', municipalityCode: '', colony: ''
          };

          console.log('=== VIAL goToConfirm ===');
          console.log('selectedAddress:', this.selectedAddress);
          console.log('currentMapLocation:', this.currentMapLocation);

          if (this.currentMapLocation?.isCurrentLocation) {
            console.log('CASO 1: Ubicación actual');
            latitude = this.currentMapLocation.lat.toString();
            longitude = this.currentMapLocation.lng.toString();
            currentCode.callenum = this.currentMapLocation.identifier || "Ubicación actual";
            currentCode.cp = this.currentMapLocation?.postalCode || "";
            currentCode.statecode = this.currentMapLocation?.codeEstado?.id || this.currentMapLocation?.codeEstado || "";
            currentCode.municipalityCode = this.currentMapLocation?.codeMunicipio?.id || this.currentMapLocation?.codeMunicipio || "";
            currentCode.colony = this.currentMapLocation?.colony || "";
          } else if (this.selectedAddress && !this.selectedAddress?.isCurrentLocation && this.selectedAddress?.idAddress) {
            console.log('CASO 2: Dirección guardada');
            latitude = this.currentMapLocation.lat.toString();
            longitude = this.currentMapLocation.lng.toString();
            currentCode.cp = this.selectedAddress?.cp || this.currentMapLocation?.postalCode || "";
            currentCode.callenum = `${this.selectedAddress?.streetNumber || ''} Int ${this.selectedAddress?.interiorDepartament || ''}, ${this.selectedAddress?.colony || ''}, ${this.selectedAddress?.cp || ''}, ${this.selectedAddress?.municipality || ''}, ${this.selectedAddress?.state || ''}`;
            currentCode.statecode = this.selectedAddress?.codeent || "";
            currentCode.municipalityCode = this.selectedAddress?.codemun || "";
            currentCode.colony = this.selectedAddress?.colony || "";
          } else {
            console.log('CASO 3: Default/Búsqueda mapa');
            latitude = this.currentMapLocation.lat.toString();
            longitude = this.currentMapLocation.lng.toString();
            currentCode.cp = this.currentMapLocation?.postalCode || this.currentMapLocation?.place?.address?.postcode || "";
            currentCode.callenum = this.currentMapLocation?.identifier || this.currentMapLocation?.streetNumber || this.currentMapLocation?.name || this.currentMapLocation?.place?.address?.road || "";
            currentCode.statecode = this.currentMapLocation?.country_code || this.currentMapLocation?.codeEstado?.id || "";
            currentCode.municipalityCode = this.currentMapLocation?.codemun || this.currentMapLocation?.codeMunicipio?.id || "";
            currentCode.colony = this.currentMapLocation?.colony || "";
          }

          console.log('currentCode.callenum final:', currentCode.callenum);

          const selectedName = this.selectedPatient === 'titular' ? this.nameOwner : this.selectedPatient;
          const { firstName: selectedFirstName, lastName: selectedLastName, secondLastName: selectedSecondLastName } = this.splitFullName(selectedName);
          const { firstName: ownerFirstName, lastName: ownerLastName, secondLastName: ownerSecondLastName } = this.splitFullName(this.nameOwner);

      const payload: VialAssistanceRequest = {
            identifier: {
              tenants: 'adff7f6a-e97d-11eb-9a03-0242ac130003',
              app: 'PortalAsistencia',
            },
            petition: {
              serviceId: serviceData.clServicio || this.clServicio || 1,
              subServiceId: serviceData.clSubservicio || this.clSubservicio || this.getSubserviceVialType(this.nameService || ''),
              hasAssistance: false,
              key: userData.memberships || '',
              areaCode1: "044",
              phone1: userData.phone || '',
              stateCode: currentCode?.statecode || '',
              municipalityCode: currentCode?.municipalityCode || "",
              callenum: currentCode.callenum.substring(0, 99),
              cp: currentCode?.cp || "",
              colonia:currentCode?.colony || "",
              statusId: 0,
              accountId: account,
              appUserId: 1,
              countryId: 115,
              contactTypeId: 15,
              serviceTypeId: 1,
              sendCharge: false,
              hasAppointment: false,
              isRelevant: false,
              gender: 1,
              isOk: true,
              hasQuotation: false,
              isSise2: true,
              serviceReceptionId: 10,
              personId: 1,
              username: selectedFirstName,
              paternalSurname: selectedLastName,
              userSecondLastName: selectedSecondLastName,
              contactName: selectedName,
              userFirstNamePf: ownerFirstName,
              userLastNamePf: ownerLastName,
              userSecondLastNamePf: ownerSecondLastName,
              ourUser: userData.username || '',
              externalCabRepName: "API CLIENTES",
              folio: crypto.randomUUID(),
              longitude: `${latitude}`,
              latitude: `${longitude}`,
              incidentDescription:currentCode.callenum,
              clRecepcionServicio: 10,
              email: this.email || '',
            }
          }

          this.apiService.postVialAssistance(payload).subscribe({
            next: (res) => {
              if (res.code === 200) {
                const payloadSubService: VialAssistanceSubserviceRequest = {
                  identifier: {
                    tenants: 'adff7f6a-e97d-11eb-9a03-0242ac130003',
                    app: 'PortalAsistencia',
                  },
                  petition: {
                    clexpediente: res.response.id,
                    claveamis: vehicle.id,
                    codigomarca: vehicle.catalogbrand.reference,
                    modelo: vehicle.model,
                    placas: vehicle.plates,
                    noserie: vehicle.serialNumber,
                    nivel: vehicle.shielding ? vehicle.shieldingCatalog.description : '0',
                    clcolorauto: vehicle.colorcatalog.idColor,
                    clblindaje: vehicle.shielding ? vehicle.shieldingCatalog.idShielding : 0,
                    cllugarevento: 2,
                    latitudorig: `${latitude}`,
                    longitudorig: `${longitude}`
                  }
                }

                this.apiService.postVialssistanceSubservice(payloadSubService,  this.getSubserviceVialType(this.nameService || '').toString()).subscribe({
                  next:(resSub)=>{
                    const assistanceData = {
                      clave: userData.memberships || '',
                      clexpediente: res.response.id,
                      nuestrousuario: userData.name || '',
                      clcuenta: account.toString(),
                      nombre: serviceData.dsSubServicio || this.dsSubServicio || this.nameService || 'Asistencia Vial',
                      clservicio: (serviceData.clServicio || this.clServicio || 1).toString(),
                      dsservicio: serviceData.dsServicio || 'Vial',
                      clsubservicio: (serviceData.clSubservicio || this.clSubservicio || '').toString(),
                      dssubservicio: serviceData.dsSubServicio || this.dsSubServicio || this.nameService || '',
                      clestatus: '0',
                      dsestatus: 'Abierto',
                      fecharegistro: new Date().toISOString()
                    };

                    const navigationExtras: NavigationExtras = {
                      state: assistanceData,
                      queryParams: assistanceData
                    };

                    this.router.navigate(['/solicitud/detalle/', res.response.id], navigationExtras);
                    this.loader.hide();
                  },
                  error: (err) => {
                    this.loader.hide();
                    if (err.status === 409) {
                      console.error('Error inesperado:', err);
                    } else {
                      console.error('Error inesperado:', err);
                    }
                  },
                });

              } else {

              }
            },
            error: (err) => {
              this.loader.hide();
              if (err.status === 409) {
                console.error('Error inesperado:', err);
              } else {
                console.error('Error inesperado:', err);
              }
            },
          });

        } else {

        }
      });
    }


  private splitFullName(fullName: string) {
    const parts = fullName.trim().split(/\s+/).filter(p => p);
    if (parts.length <= 1) return { firstName: parts[0] || '', lastName: '', secondLastName: '' };
    if (parts.length === 2) return { firstName: parts[0], lastName: parts[1], secondLastName: '' };
    if (parts.length === 3) return { firstName: parts[0], lastName: parts[1], secondLastName: parts[2] };
    // Para nombres con 4 o más partes, asumir que los primeros 2 son nombres y los últimos 2 son apellidos
    return {
      firstName: parts.slice(0, 2).join(' '),
      lastName: parts[parts.length - 2],
      secondLastName: parts[parts.length - 1]
    };
  }

  private getSubserviceVialType(type: string) {
    switch (type) {
      case 'Arrastre de Grúa': return 211;
      case 'Paso de Corriente': return 212;
      case 'Cambio de Llanta':return 213;
      case 'Suministro de Gasolina':return 214;
      default: return 211;
    }
  }
}
